<template>
  <div id="bannerbutton-comp" class="bannerbutton-comp" :class="{'master-section': bannerData.banner_width}" >
    <div v-if="showBanner" class="master-block-banner_image  mx-0 px-0" :class="{'master-section': bannerData.banner_width}"
    style="height: 100%"
    >

      <div class=" emm-inner-banner" :class="`${bannerData.banner_text_position}`"  style="height: 100%;
    position: relative;">  <div class="overlay" v-if="!isMobile || bannerData.size !== '1'"></div>
        <a v-if="(bannerData.link_type === 'section' || bannerData.link_type === 'alternate') && bannerData.button_link" class="master-section-link" :href="bannerData.button_link?.url" target="<?= $link_target; ?>"
              :style="(bannerData.size === '1' && windowWidth < 768) ? '' : 'height: 100%;'"
          >
          <div class="overlay" v-if="isMobile && bannerData.size === '1'"></div>
        <!-- Desktop banner image -->
        <img
          v-if="bannerData.image_medium_pc"
          :src="bannerData.image_medium_pc"
          :data-original_src="bannerData.image_full_pc"
          alt="Banner Image"
          class="banner-pc img-fluid d-none d-md-inline alt-lazy-img"
          style="height: 100% !important;"
        />

        <!-- Mobile banner image -->
        <img
          v-if="bannerData.image_medium_mb"
          :src="bannerData.image_medium_mb"
          :data-original_src="bannerData.image_full_mb"
          alt="Mobile Banner Image"
          class="banner-mb img-fluid d-md-none mb-30px alt-lazy-img"
          :style="(bannerData.size === '1' && windowWidth < 768) ? '' : 'height: 100% !important;'"
        />
        <img
          v-else="bannerData.image_medium_pc"
          :src="bannerData.image_medium_pc"
          :data-original_src="bannerData.image_full_pc"
          alt="Mobile Banner Image"
          class="banner-mb img-fluid d-md-none mb-30px alt-lazy-img"
          :style="(bannerData.size === '1' && windowWidth < 768) ? '' : 'height: 100% !important;'"
        />

        <!-- Banner Text Content -->
        <div
          class="master-block-banner-text"
          :class="`${bannerData.mobile_text_position} text-${bannerData.banner_text_position} col-12 col-md-6 offset-md-3 mb-60px`"
          :style="bannerTextStyle"
          style="
          position: absolute;
          "
        >
        <Heading
          level="2"
          v-if="bannerData.title"
          style="margin:0"
          class="agp-normal"
        >
          {{ bannerData.title }}
          <template v-if="bannerData.chinese_title">
            <br>
            {{ bannerData.chinese_title }}
          </template>
        </Heading>

          <!-- Render long_description as HTML -->
          <p
            v-if="bannerData.long_description"
            class="agp-normal"
            v-html="textValue"
          ></p>

          <!-- Button -->
             <a
               v-if="bannerData.button_link && bannerData.button_link.title"
               :href="bannerData.button_link.url"
               :target="bannerData.button_link.target || '_self'"
               class="btn-outline-dark btn "
               :style="buttonStyles"
                @mouseover="hover = true"
                @mouseleave="hover = false"
             >
               {{ bannerData.button_link.title }}
               <!-- <span class="css-arrow css-arrow-right" :style="{ borderColor: bannerData.banner_text_color }"></span> -->
             </a>
        </div>
      </a>
      <div
        v-else
        style="position: relative"
        :style="(bannerData.size === '1' && windowWidth < 768) ? '' : 'height: 100%;'" >
        <div class="overlay" v-if="isMobile && bannerData.size === '1'"></div>
          <!-- Desktop banner image -->
          <img
          v-if="bannerData.image_medium_pc"
          :src="bannerData.image_medium_pc"
          :data-original_src="bannerData.image_full_pc"
          alt="Banner Image"
          class="banner-pc img-fluid d-none d-md-inline alt-lazy-img"
          style="height: 100% !important;"

        />
        <!-- Mobile banner image -->
        <img
          v-if="bannerData.image_medium_mb"
          :src="bannerData.image_medium_mb"
          :data-original_src="bannerData.image_full_mb"
          alt="Mobile Banner Image"
          class="banner-mb img-fluid d-md-none mb-30px alt-lazy-img"
          :style="(bannerData.size === '1' && windowWidth < 768) ? '' : 'height: 100% !important;'"

        />
        <img
          v-else="bannerData.image_medium_pc"
          :src="bannerData.image_medium_pc"
          :data-original_src="bannerData.image_full_pc"
          alt="Mobile Banner Image"
          class="banner-mb img-fluid d-md-none mb-30px alt-lazy-img"
          :style="(bannerData.size === '1' && windowWidth < 768) ? '' : 'height: 100% !important;'"

        />

        <!-- Banner Text Content -->
        <div
          class="master-block-banner-text"
          :class="`${bannerData.mobile_text_position} text-${bannerData.banner_text_position} mb-30px`"
          :style="bannerTextStyle"
          style="position: absolute;">

          <Heading
            level="2"
            v-if="bannerData.title"
            :style="headingStyle??''"
            class="agp-normal"
             style="margin:0"
          >
          {{ bannerData.title }}
          <template v-if="bannerData.chinese_title">
            <br>
            {{ bannerData.chinese_title }}
          </template>
        </Heading>

          <!-- Render long_description as HTML -->
          <p
            v-if="bannerData.long_description"
             :style="headingStyle"
            class="agp-normal"
            v-html="bannerData.long_description"
          ></p>
          <!-- v-html="textValue" -->

          <!-- Button -->
             <a
               v-if="bannerData.button_link?.url && bannerData.button_link.title && (bannerData.link_type =='button' || bannerData.link_type =='alternate')"
               :href="bannerData.button_link.url"
               :target="bannerData.button_link.target || '_self'"
               class="btn-outline-dark btn "
               :style="buttonStyles"
                @mouseover="hover = bannerData.banner_width ? true : false"
                @mouseleave="hover = bannerData.banner_width ? true : false"
             >
               {{ bannerData.button_link.title }}
               <!-- <span class="css-arrow css-arrow-right" :style="{ borderColor: bannerData.banner_text_color }"></span> -->
             </a>
             <a
               v-if="bannerData.button_link && bannerData.link_type==undefined"
               :href="bannerData.button_link.url"
               :target="bannerData.button_link.target || '_self'"
               class="btn-outline-dark btn "
               :style="buttonStyles"
                @mouseover="hover = bannerData.banner_width ? true : false"
                @mouseleave="hover = bannerData.banner_width ? true : false"
             >
               {{ bannerData.button_link.title }}
               <!-- <span class="css-arrow css-arrow-right" :style="{ borderColor: bannerData.banner_text_color }"></span> -->
             </a>

        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// import { radians } from 'pdf-lib';
// import { transform } from 'html2canvas/dist/types/css/property-descriptors/transform';
import { ref, computed } from 'vue';
import Heading from '~/components/Heading.vue';
// Define the structure of the banner data
interface ButtonLink {
  url?: string;
  target?: string;
  title?: string;
}
interface Bannerimage {
  url?: string;

}
interface BannerData {
  enable_banner: boolean;
  image_medium_pc?: string;
  image_full_pc?: string;
  image_medium_mb?: string;
  image_full_mb?: string;
  title?: string;
  long_description?: string;
  banner_text_color?: string;
  banner_text_color_mb?: string;
  text_color_hover?: string;
  button_color?: string;
  button_color_hover?: string;
  button_border?: string;
  max_width_banner_text?: string;
  mobile_text_position?: string;
  banner_text_position?: string;
  button_link?: ButtonLink;
  link_type? : string;
  banner_width? : string;
  chinese_title? : string;
  size: string;
}

// Define the props with type
const props = defineProps<{
  bannerDataProp: BannerData,
  padding_bottom?: string, // Optional prop
}>();

// Use a computed property to handle default value
const paddingBottomStyle = computed(() => {
  return props.padding_bottom || '60px';
});

// Use the prop data
// const bannerData = ref(props.bannerDataProp);
const bannerData = ref<BannerData>({
  enable_banner: true,
});
const bannerSize = props.bannerDataProp.size;
const textValue = ref<string>('');
watch(()=>props.bannerDataProp.long_description,(newValue) =>{
  if(newValue!=undefined){
    textValue.value = newValue;
  }
})
onMounted(() => {
  if(props.bannerDataProp && props.bannerDataProp.long_description !== undefined){
    textValue.value = props.bannerDataProp.long_description;
  }
  setTimeout(() => {
    altLazyIO();
  }, 300);
})

// Watch for changes in props.bannerDataProp and update bannerData accordingly
watchEffect(() => {
  if (props.bannerDataProp) {
    bannerData.value = {
      ...props.bannerDataProp,
      enable_banner: props.bannerDataProp.enable_banner ?? true // Default to true if undefined
    };
  }

});


// Computed property to check if the banner should be displayed
const showBanner = computed(() => {
  return (bannerData.value.enable_banner !== false) && (
    bannerData.value.image_full_pc ||
    bannerData.value.title
  );
});
const windowWidth = ref(0);
const isMobile = ref(false);
const headingStyle = computed(() => {
  if (!bannerData.value) return {}; // safeguard for undefined bannerData
  let maxWithStyle = bannerData.value.max_width_banner_text ? `${bannerData.value.max_width_banner_text}%` : '600px';
  if (isMobile.value && bannerData.value.size === '1'){
    maxWithStyle = '100%';
  }
  return {
    color: `${isMobile.value ? bannerData.value.banner_text_color_mb : bannerData.value.banner_text_color} !important`,
    maxWidth: maxWithStyle,
  }
})

const bannerTextStyle = computed(() => {
  if (!bannerData.value) return {}; // safeguard for undefined bannerData

  // Set isMobile based on window width
  isMobile.value = windowWidth.value < 768;
  let maxWithStyle = bannerData.value.max_width_banner_text ? `${bannerData.value.max_width_banner_text}%` : '600px';
  if (isMobile.value && bannerData.value.size === '1'){
    maxWithStyle = '100%';
  }
  let rightStyle = ['top-right', 'right-bottom', 'bottom-center'].includes(bannerData.value.banner_text_position) ? '0' : undefined;
  if (isMobile.value && bannerData.value.size === '1'){
    rightStyle = '50%';
  }
  let leftStyle = ['left-top', 'left-bottom', 'bottom-center'].includes(bannerData.value.banner_text_position) ? '0' : undefined;
  if (isMobile.value && bannerData.value.size === '1'){
    leftStyle = undefined;
  }
  let topStyle = ['left-top', 'top-right'].includes(bannerData.value.banner_text_position) ? '0' : undefined;
  let bottomStyle = ['left-bottom', 'right-bottom', 'bottom-center'].includes(bannerData.value.banner_text_position) ? '0' : undefined;
  if (isMobile.value && bannerData.value.size === '1' && topStyle === '0'){
    topStyle = '10px';
    bottomStyle = undefined
  }
  if (isMobile.value && bannerData.value.size === '1' && bottomStyle === '0'){
    topStyle = undefined;
    bottomStyle = '0'
  }

  let textAlignStyle = ['top-right', 'right-bottom'].includes(bannerData.value.banner_text_position)
  ? 'right'
  : ['left-top', 'left-bottom'].includes(bannerData.value.banner_text_position)
  ? 'left'
  : 'center';
  if (isMobile.value && bannerData.value.size === '1'){
    textAlignStyle = 'center';
  }
  return {
    color: `${isMobile.value ? bannerData.value.banner_text_color_mb : bannerData.value.banner_text_color} !important`,
    // maxWidth: maxWithStyle,
    bottom: bottomStyle,
    top: topStyle,
    left: leftStyle,
    right: rightStyle,
    textAlign: textAlignStyle,
    margin: ['bottom-center'].includes(bannerData.value.banner_text_position) ? '0 auto 30px auto !important' : isMobile.value && bannerData.value.size === '1' ? '0 0 10px 0 !important' : '30px',
    transform: isMobile.value && bannerData.value.size === '1' ? 'translateX(50%)' : undefined,
    width: isMobile.value && bannerData.value.size === '1' ? '80%' : undefined,
    zIndex: 2,
  };
});

// Update window width on mount and resize
onMounted(() => {
  windowWidth.value = window.innerWidth;

  window.addEventListener('resize', () => {
    windowWidth.value = window.innerWidth;
    console.log(bannerData.value.banner_text_color_mb,'bannerData.value.banner_text_color_mb')
  });
});

// Hover state
const hover = ref(false);

// Computed styles for the button
const buttonStyles = computed(() => ({
  color: '#ffffff !important',
  borderColor: bannerData.value.banner_text_color,
  backgroundColor: hover.value ? bannerData.value.button_color_hover : bannerData.value.button_color,
  transition: 'background-color 0.3s ease-in-out, color 0.3s ease-in-out',
  borderRadius: bannerData.value.button_border
}));

// Computed styles for the arrow
const arrowStyles = computed(() => ({
  borderColor: hover.value ? 'transparent' : bannerData.value.banner_text_color,
  transition: 'border-color 0.3s ease-in-out'
}));

// onMounted(() => {
//     altLazyIO();
// })
</script>

<style lang="scss">
  @import "@/assets/scss/components/listing/_product-block.scss";
  .master-block-banner-text {
    .heading {
      h2 {
        @media screen and (max-width: 460px){
          margin: 0 auto !important;
        }
      }
    }
    > p {
      @media screen and (max-width: 460px){
        margin: 0 auto;
      }
    }
  }

  .left-bottom,
  .left-top {
    .master-block-banner-text {
      .heading {
        h2 {
          @media screen and (max-width: 460px){
            margin-left: 0 !important;
          }
        }
      }
      > p {
        @media screen and (max-width: 460px){
          margin-left: 0 !important;
        }
      }

      a.btn {
        @media screen and (max-width: 460px){
          margin-top: 5px !important;
        }
      }
    }
  }

  .top-right,
  .right-bottom,
  .right-top {
    .master-block-banner-text {
      .heading {
        h2 {
          @media screen and (max-width: 460px){
            margin-right: 0 !important;
          }
        }
      }
      > p {
        @media screen and (max-width: 460px){
          margin-right: 0 !important;
        }
      }

      a.btn {
        @media screen and (max-width: 460px){
          margin-top: 5px !important;
        }
      }
    }
  }



  .text-bottom-center {
    &.master-block-banner-text {
      .heading {
        h2 {
            margin: 0 auto !important;
        }
      }
      > p {
          margin: 0 auto;
      }
    }
  }
  .text-top-right {
    &.master-block-banner-text {
      .heading {
        h2 {
          margin-left: auto !important;
        }
      }
      > p {
        margin-left: auto !important;
      }
    }
  }
  .text-right-bottom {
    &.master-block-banner-text {
      .heading {
        h2 {
          margin-left: auto !important;
        }
      }
      > p {
        margin-left: auto !important;
      }
    }
  }

  .master-block-banner-text {
    .btn:not(.master-main-banner-text a.btn, .skj-cta .btn_block):hover {
        border: none !important;
    }
  }

</style>